<template>
  <div>
    <vue-headful :title="pageTitle"/>
    <v-form ref="form" lazy-validation>
      <v-layout>
        <h1><span>{{title}}</span></h1>
        <v-spacer></v-spacer>
        <v-btn color="primary" class="mx-1" dark @click="save">Сохранить</v-btn>
        <v-btn color="primary" class="mx-1" dark @click="clear">Очистить</v-btn>
        <v-btn color="primary" class="ml-1 mr-0" dark @click="goBack">Вернуться</v-btn>
      </v-layout>
      <v-alert :value="alert" type="success">Группа сохранена</v-alert>
      <v-card>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
                tabindex="1"
                label="Название"
                v-model="editedItem.name"
                :error-messages="nameErrors"
                required
              />
            </v-flex>
            <v-flex xs4 pr-2>
              <v-select
                :items="categories"
                v-model="editedItem.category"
                label="Категория"
                persistent-hint
                :error-messages="categoryErrors"
              />
            </v-flex>
            <v-flex xs4 px-2>
              <v-autocomplete
                v-model="editedItem.organization.id"
                :items="organizations"
                item-value="id"
                item-text="name"
                search-input
                :disabled="editing || $route.query.orgId"
                label="Организация"
                persistent-hint
                :error-messages="organizationErrors"
              />
            </v-flex>
            <v-flex xs4 pl-2>
              <v-menu
                :close-on-content-click="false"
                v-model="datePicker"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px">

                <v-text-field
                  slot="activator"
                  v-model="editedItem.attestationInfo.date"
                  label="Дата аттестации"
                  persistent-hint
                  prepend-icon="event"
                  readonly
                  :error-messages="dateErrors"
                />
                <v-date-picker locale="ru-RU" first-day-of-week="1" v-model="date" no-title :min="minDate"
                               @input="datePicker = false"/>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-form>
    <ErrorDialog :dialog="errorDialog"/>
  </div>
</template>

<script>
import SettingsService from '@/services/SettingsService'
import ObjectUtils from '@/utils/ObjectUtils'
import Dialog from '@/components/fragments/Dialog'
import {required} from 'vuelidate/lib/validators'
import GroupService from '@/services/GroupService'
import CategoryService from '@/services/CategoryService'
import OrganizationService from '@/services/OrganizationService'
import ErrorDialog from '@/components/fragments/ErrorDialog'

export default {
  props: {
    group: Object,
    editing: false
  },
  components: {ErrorDialog, Dialog},
  data: () => ({
    alert: false,
    defaultItem: GroupService.getDefaultItem(),
    editedItem: {},
    categories: CategoryService.getList(),
    date: null,
    datePicker: false,
    organizations: [],
    errorDialog: {
      status: false,
      errors: [],
      title: 'Ошибка при сохранении'
    },
    groupService: undefined,
    organizationService: undefined
  }),
  computed: {
    title () {
      return this.editing ? 'Редактирование группы' : 'Добавление группы'
    },
    pageTitle () {
      return SettingsService.pageTitle(this.title)
    },
    nameErrors () {
      const errors = []
      if (!this.$v.editedItem.name.$dirty) return errors
      !this.$v.editedItem.name.required && errors.push('Поле должно быть заполнено.')
      return errors
    },
    categoryErrors () {
      const errors = []
      if (!this.$v.editedItem.category.$dirty) return errors
      !this.$v.editedItem.category.required && errors.push('Поле должно быть заполнено.')
      return errors
    },
    organizationErrors () {
      const errors = []
      if (!this.$v.editedItem.organization.id.$dirty) return errors
      !this.$v.editedItem.organization.id.required && errors.push('Поле должно быть заполнено.')
      return errors
    },
    dateErrors () {
      const errors = []
      if (!this.$v.editedItem.attestationInfo.date.$dirty) return errors
      !this.$v.editedItem.attestationInfo.date.required && errors.push('Поле должно быть заполнено.')
      return errors
    },
    minDate () {
      let date = new Date()
      date.setDate(date.getDate() + 1)
      return date.toISOString().slice(0, 10)
    }
  },
  methods: {
    save () {
      this.alert = false
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.groupService.saveItem(this.editedItem, this.editing, (data) => {
          if (data.status) {
            this.alert = true
            if (!this.editing) this.clear()
          } else {
            this.errorDialog.errors = data.errors
            this.errorDialog.status = true
          }
        })
      }
    },
    goBack () {
      this.$router.back()
    },
    clear () {
      this.$v.$reset()
      this.editedItem = ObjectUtils.jsonCopy(this.defaultItem)
      this.date = null
    },
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
    parseDate (date) {
      if (!date) return null
      const [day, month, year] = date.split('.')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    }
  },
  created () {
    this.groupService = new GroupService(this.$store)
    this.organizationService = new OrganizationService(this.$store)
    this.organizationService.getList((data) => {
      this.organizations = data.list
    }, {
      limit: 0,
      orgId: this.$route.query.orgId
    })
    this.editedItem = ObjectUtils.jsonCopy(this.defaultItem)
    if (this.$route.query.orgId) {
      this.editedItem.organization.id = Number.parseInt(this.$route.query.orgId)
    }
  },
  watch: {
    group (val) {
      this.editedItem = ObjectUtils.jsonCopy(val)
      let date = this.editedItem.attestationInfo.date.split('.')
      this.date = `${date[2]}-${date[1]}-${date[0]}`
    },
    date (val) {
      this.editedItem.attestationInfo.date = this.formatDate(val)
    },
    'errorDialog.status' (val) {
      if (!val) {
        this.errorDialog.errors = []
      }
    }
  },
  validations: {
    editedItem: {
      name: {required},
      category: {required},
      attestationInfo: {
        date: {required}
      },
      organization: {
        id: {required}
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/admin/group/EditForm.vue